import { ToolBarStandardButton, ToolBarStandardButtonType } from "../core/components/toolBar";
import { Grid } from "../core/components/grid";
import { HTTPService } from "../core/util/httpManager";
import React from "react";

export default class HistoryGrid extends React.Component<any, any>{
    private _gridData = [];
    private _translations = {};
    private _dataUrl: string;

    constructor(props) {
        super(props)
        this._dataUrl = "Procedure/GetHistory?id=" + this.props.entity.ProblemNr;
        this._translations = this.props.translations;
    }

    private _getGridData() {
        HTTPService.get(this._dataUrl)
            .then(result => {
                this._gridData = result.Data;
                this.setState({});
            });
    }

    handleClickStandardButton = (type: ToolBarStandardButtonType, dataItem: any) => {
        if (type === ToolBarStandardButtonType.RELOAD) {
            this._getGridData();
        }
    }

    componentDidMount() {
        this._getGridData();
    }

    render() {
        const standardButtons: Array<ToolBarStandardButton> = [];
        standardButtons.push({ type: ToolBarStandardButtonType.RELOAD, caption: this._translations["MonitorBaum.NeuLaden"], enabled: true });

        const content = <Grid data={this._gridData} options={this.props.context.historyGrid} id="ticketHistory"
            standardButtons={standardButtons} onClickStandardButton={this.handleClickStandardButton}
            useFloatingButtons={true}
        />

        return (content);
    }
}
